import moment from "moment";
import paginationComponent from "../../components/pagination/pagination.component";
import { formats } from "../../config/constants";
import ImeiSnAnalysisSoIncreaseStatusModel from "../../models/imei-sn-validation-log/imei-sn-analysis-so-increase-status.model";
import ViewBase from "../view-base.view";

/**
* IMEI/SN Analysis - S/O Increase Status View
* 
* @author cmc.nttruong1
*/

export default function ImeiSnAnalysisSoIncreaseStatusView() {
  ViewBase.call(this)

  const LOG_TYPE = {
    INPUT: { name: 'by Input User', value: 'SO_INCREASE_PROMOTER' },
    CHANNEL: { name: 'by Channel', value: 'SO_INCREASE_CHANNEL' }
  }

  const DEFAULT_FILTERS = {
    week: moment().format(formats.WEEK_FORMAT),
    type: LOG_TYPE.INPUT.value
  }

  const DEFAULT_PAGINATION = {
    pageSize: 10,
    pageIndex: 1,
    totalItems: 0
  }

  let filters = structuredClone(DEFAULT_FILTERS);
  let pagination = structuredClone(DEFAULT_PAGINATION);
  let logResults = [];
  let currentLogType = LOG_TYPE.INPUT.value;
  let currentFilters = {};

  const toParams = () => {
    currentLogType = currentFilters.type;
    return {
      logWeek: moment(currentFilters.week).format(formats.API_WEEK_FORMAT),
      logType: currentLogType,
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize
    }
  }

  const search = (payload) => {
    this.showLoading();
    ImeiSnAnalysisSoIncreaseStatusModel.search(payload)
      .then((res) => {
        pagination.totalItems = res.total;
        logResults = res.data;
      })
      .catch((error) => { this.handleError(error) })
      .finally(() => { this.hideLoading(); })
  }

  const handleSearch = (e) => {
    e.preventDefault();
    if (e.target.checkValidity()) {
      pagination.pageIndex = DEFAULT_PAGINATION.pageIndex;
      currentFilters = structuredClone(filters);
      search(toParams());
    }
    e.target.classList.add("was-validated");
  }

  const exportFailReports = () => {
    this.showLoading();
    let payload = {
      storedProcedureCode: "62",
      params: [
        { code: "122", value: moment(currentFilters.week).format(formats.API_WEEK_FORMAT) }, //log week
        { code: "123", value: currentFilters.type } // log type
      ],
      excelSheetNames: ["IMEI_SN_Analysis-SO_Increase_Fail_Status"]
    }

    ImeiSnAnalysisSoIncreaseStatusModel.exportFail(payload)
      .catch((error) => { this.handleError(error) })
      .finally(() => this.hideLoading())
  }

  const exportIncreaseReports = (objectCode) => {
    this.showLoading();
    let payload = {
      storedProcedureCode: "63",
      params: [
        { code: "122", value: moment(currentFilters.week).format(formats.API_WEEK_FORMAT) }, //log week
        { code: "123", value: currentFilters.type }, // log type
        { code: "126", value: objectCode }, // Object code
        { code: "125", value: "THIS" } // ExcelType
      ],
      excelSheetNames: ["IMEI_SN_Analysis-SO_Increase"]
    }

    ImeiSnAnalysisSoIncreaseStatusModel.exportIncrease(payload)
      .catch((error) => { this.handleError(error) })
      .finally(() => this.hideLoading())
  }

  const onPageSizeChanged = (pageIndex, pageSize) => {
    pagination.pageIndex = pageIndex;
    pagination.pageSize = pageSize;
    search(toParams());
  }

  const onPageChanged = (pageIndex) => {
    pagination.pageIndex = pageIndex;
    search(toParams());
  }

  return {
    view: () => {
      return [
        /* SEARCH */
        m(".d-flex.flex-column.align-items-end.gap-2.mb-3",
          m(".collapse.show#search-section.w-100",
            m('.card.mb-3',
              m('.card-body',
                m('form.needs-validation[novalidate].row.g-2',
                  { onsubmit: handleSearch },
                  m(".col-lg-3.col-md-6.position-relative",
                    m('label.form-label.mandatory[for="log-week"]', this.getText('LT00000337', 'Week')),
                    m('input#log-week.form-control[name="log-week"][type="week"][required]', {
                      value: filters.week,
                      onchange: (e) => {
                        filters.week = e.target.value;
                      }
                    }),
                    m('.invalid-tooltip', this.getText("LT00000729", "This field is required")),
                  ),
                  m('.col-lg-3.col-md-6.position-relative',
                    m('label.form-label[for="logType"]',
                      this.getText('LT00000117', 'Type')
                    ),
                    m('#logType', { value: filters.type, onchange: (e) => { filters.type = e.target.value; } },
                      m('.form-check.form-check-inline',
                        m('input#typeInputUser.form-check-input[type="radio"]',
                          {
                            value: LOG_TYPE.INPUT.value,
                            checked: filters.type == LOG_TYPE.INPUT.value,
                          }
                        ),
                        m('label.form-check-label[for="typeInputUser"]',
                          LOG_TYPE.INPUT.name
                        )
                      ),
                      m('.form-check.form-check-inline',
                        m('input#typeChannel.form-check-input[type="radio"]',
                          {
                            value: LOG_TYPE.CHANNEL.value,
                            checked: filters.type == LOG_TYPE.CHANNEL.value,
                          }
                        ),
                        m('label.form-check-label[for="typeChannel"]',
                          LOG_TYPE.CHANNEL.name
                        )
                      )
                    )
                  ),

                  // Search & clear buttons
                  m('.col-12.d-flex.justify-content-end.gap-2',
                    m('button.btn.btn-primary', this.getText("LT00000001", "Search")),
                  ),
                )
              )
            ),
          ),
        ),

        /* TABLE */
        m(".card",
          m(".card-body",
            m('.row.g-2.mb-3',
              m('.col-12.d-flex.justify-content-end',
                m('button.btn.btn-primary', {
                  onclick: exportFailReports,
                  disabled: !(logResults.length > 0),
                },
                  m('i.bi.bi-file-earmark-arrow-down-fill'),
                  this.getText('LT00000018', 'Excel Download'))
              ),
            ),
            m(".row.g-2",
              m(".col-12",
                m(".table-responsive",
                  m("table.table.table-hover.table-bordered",
                    m("thead",
                      m("tr.align-middle",
                        m("th.text-center", { colspan: 2 },
                          currentLogType === LOG_TYPE.INPUT.value ? this.getText("LT00000561", "Promoter") : this.getText("LT00001150", "Channel")
                        ),
                        m("th.text-center", this.getText("LT00001180", "This week S/O")),
                        m("th.text-center", this.getText("LT00001181", "4W AVG S/O")),
                        m("th.text-center", this.getText("LT00001182", "Rate")),
                      )
                    ),
                    m("tbody",
                      logResults.length == 0 &&
                      m("tr.align-middle",
                        m("td", { colspan: 5 }, this.getText("EM00000141", "No records found."))
                      ),
                      logResults.map((row) =>
                        m(`tr.align-middle`,
                          m("td", m("span", row.objectCd)),
                          m("td", m("span.cursor-text", row.objectNm)),
                          m("td.text-center",
                            m("span.cursor-pointer.text-primary",
                              { onclick: () => { exportIncreaseReports(row.objectCd) } },
                              row.count)),
                          m("td.text-center", m("span", row.etcCount)),
                          m("td.text-center", m("span", (row.rate).toFixed(2) + "%")),
                        )
                      )
                    )
                  )
                )
              ),
              logResults.length > 0 &&
              m(".col-12",
                m(paginationComponent, {
                  currentPage: pagination.pageIndex,
                  pageSize: pagination.pageSize,
                  totalItems: pagination.totalItems,
                  onPageChanged: onPageChanged,
                  onPageSizeChanged: onPageSizeChanged,
                })
              )
            ),
          )
        ),

        this.getBaseViews(),
      ]
    }
  }
}